import styled from 'styled-components';

export const Container = styled.div<{ withoutDots?: boolean, withoutArrows?: boolean }>`
  display: flex;
  justify-content: center;
  width: 100%;
  height: fit-content;
  margin: 0 auto;
  padding-bottom: ${({ withoutDots }) => withoutDots ? 0 : 32}px;
  padding-right: ${({ withoutArrows }) => withoutArrows ? 0 : 32}px;
  padding-left: ${({ withoutArrows }) => withoutArrows ? 0 : 32}px;
  
  div:focus-visible {
    outline: none !important;
  }
`;
